"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export function useMarketingPageTracking() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;

    void fetch("/api/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path: pathname,
        referrer: typeof document !== "undefined" ? document.referrer || null : null,
      }),
    }).catch(() => {
      // non-blocking
    });
  }, [pathname]);
}
